import useQuery from 'hooks/useQuery'
import React, { createContext, useMemo } from 'react'
import { Outlet } from 'react-router-dom'

export const ClientDataContext = createContext({
  accounts: {},
  fetchAccounts: async () => {},
})

const ClientDataProvider = ({ children }) => {
  const { data: accounts, makeRequest: fetchAccounts } = useQuery({
    defaultEndpoint: '/clients/accounts',
  })

  const contextValue = useMemo(
    () => ({
      accounts: accounts?.accounts || [],
      fetchAccounts,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [accounts],
  )
  return (
    <ClientDataContext.Provider value={contextValue}>
      <Outlet />
    </ClientDataContext.Provider>
  )
}

export default ClientDataProvider
